export type WebPushControllerStatus =
  | "preparing"
  | "unsupported"
  | "install_required"
  | "unavailable"
  | "denied"
  | "inactive"
  | "active"
  | "restore_required"
  | "unbound"
  | "error";

interface ResolveWebPushControllerStatusInput {
  capability: WebPushControllerStatus;
  error: Error | null;
  hasSubscription: boolean;
  permission: NotificationPermission | null;
  serverBound: boolean | null;
  serverSubscriptionStatus?: "active" | "invalid" | "disabled" | "detached" | null;
}

/** Resolves one deterministic current-browser state from capability, permission, and binding. */
export function resolveWebPushControllerStatus(
  input: ResolveWebPushControllerStatusInput,
): WebPushControllerStatus {
  if (input.capability !== "inactive" && input.capability !== "error") {
    return input.capability;
  }
  if (input.permission === "denied") return "denied";
  if (input.capability === "error") return "error";
  if (input.serverSubscriptionStatus === "invalid") return "restore_required";
  if (input.hasSubscription && input.serverBound === true) return "active";
  if (input.hasSubscription) return "unbound";
  if (input.error) return "error";
  return "inactive";
}
